import { IApplicationState } from '../../types/redux';

export function getReliableHouses(state: IApplicationState) {
  return state.newbuilding.reliableHouses;
}
